import { http } from "@/core/ApiConfig";
import { Service } from "../shared/Service";

export class UsuarioService extends Service{

  constructor(){
    super('usuario');
  }
  
}